export default __webpack_public_path__ + "static/brand-colors-mic-annotation-dark-037f40edc7abcb459635b03aa1173496ee3dc2c536b577b6c0ca4de21e43a8f5.png";